import React, {Fragment} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Paper from "@mui/material/Paper";
import TableContainer from '@mui/material/TableContainer';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {v4} from 'uuid';
import Button from "@mui/material/Button";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ClearIcon from '@mui/icons-material/Clear';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import Grid from "@mui/material/Grid";
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import {Tooltip} from "@mui/material";
import GavelIcon from '@mui/icons-material/Gavel';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';
import GroupsIcon from '@mui/icons-material/Groups';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import {s_ini} from "../_signals/s_ini";
import {s_char} from "../_signals/s_char";
import {charModsHasSource} from "../_sig_api/charMods";
import {
    s_char_mods_aggressiv,
    s_char_mods_bedraengt,
    s_char_mods_defensiv,
    s_char_mods_niederschlag
} from "../_signals/s_char_mods";
import {useSignals} from "@preact/signals-react/runtime";
import {IIni} from "../_interfaces/IIni";
import {IniClear, IniNext, IniSet, IniUnset, IniWait} from "../_api/BEIni";
import {ModsSourceAdd, ModsSourceDelete} from "../_api/BEMods";
import {s_app_cid, s_app_rid, s_app_sl} from "../_signals/s_app";

/*
import AltRouteIcon from '@mui/icons-material/AltRoute';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
*/
function Initiative() {
    useSignals()
    const niedergeschlagen = (cid:string) => {

        if (charModsHasSource('state_niederschlag')) {
            ModsSourceDelete(cid,'state_niederschlag','')
            return
        }

        ModsSourceAdd(cid,'state_niederschlag','')

    }

    const bedraengt = (cid:string) => {
        if (charModsHasSource('state_bedraengt')) {
            ModsSourceDelete(cid,'state_bedraengt','')
            return;
        }
        ModsSourceAdd(cid,'state_bedraengt','')

    }

    const aggressiv = (cid:string) => {

        const hasA = charModsHasSource('state_aggressiv'),
            hasD = charModsHasSource('state_defensiv');

        if (hasA) {
            ModsSourceDelete(cid,'state_aggressiv','');
        } else {
            ModsSourceAdd(cid,'state_aggressiv','');
            if (hasD) {
                ModsSourceDelete(cid,'state_defensiv','');
            }
        }


    }


    const defensiv = (cid:string) => {

        const hasA = charModsHasSource('state_aggressiv'),
            hasD = charModsHasSource('state_defensiv');

        if (hasD) {
            ModsSourceDelete(cid,'state_defensiv','');
        } else {
            ModsSourceAdd(cid,'state_defensiv','');
            if (hasA) {
                ModsSourceDelete(cid,'state_aggressiv','');

            }
        }
    }

    const rolledIniRow = (row: IIni) => {

        const sl = s_app_sl.value;
        const show = !row.nsc || (row.nsc && sl);

        return <TableRow key={v4()}>
            <TableCell className={`${row.current ? "current" : ""}`}>
                {show ? row.name : 'nsc'}
            </TableCell>
            <TableCell>{show ? row.result : '-'}</TableCell>
            <TableCell>{show ? row.wait ? <HourglassTopIcon/> : '' : ''}</TableCell>
            <TableCell style={{display: !sl ? 'none' : 'table-cell'}}>
                <Button className={'btn'} onClick={() => IniSet(row.cid, row.rid)}>✓</Button>
            </TableCell>
        </TableRow>
    }

    return <Paper className={'RolledIni'} style={{marginBottom:12,padding:6}}>
        <h3 style={{margin:4}}>Initiative</h3>
        <Grid container>
            <Grid item sm={6}>
                <TableContainer>
                    <Table stickyHeader style={{width: '100%'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Wer</TableCell>
                                <TableCell>Ergebnis</TableCell>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell style={{width: !s_app_sl.value ? 0 : ''}}>&nbsp;</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{s_ini.value.map((row, index) => rolledIniRow(row))}</TableBody>
                    </Table>
                </TableContainer>
            </Grid>

            <Grid item sm={6}>

                {s_app_sl.value ? <Grid container>
                    <Grid item xs={2}>
                        <Tooltip title="nächster">
                            <Button onClick={() => IniNext(s_app_rid.value)}><NavigateNextIcon/></Button>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={2}>
                        <Tooltip title="zurücksetzten">
                            <Button onClick={() => IniUnset(s_app_cid.value, s_app_rid.value)}><NotInterestedIcon/></Button>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={2}>
                        <Tooltip title="liste leeren">
                            <Button onClick={() => IniClear(s_app_rid.value)}><ClearIcon/>
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid> : null}

                <Grid container>
                    <Grid item xs={2}>
                        <Button onClick={() => IniWait(s_app_cid.value, s_app_rid.value)}>
                            <Tooltip title="Zurückgehalten">
                                <HourglassTopIcon
                                    color={s_ini.value.filter(i => i.cid === s_char.value.id && i.wait).length > 0 ? 'warning' : 'action'}/>
                            </Tooltip>
                        </Button>
                    </Grid>

                    <Grid item xs={2}>
                        <Button onClick={() => aggressiv(s_app_cid.value)}>
                            <Tooltip
                                title="aggressivr Angriff +3 auf Angriffs- und Schadensproben; -3 auf Körperliche und Mystische Verteidigung, 1 überanstrengung">
                                <GavelIcon color={s_char_mods_aggressiv.value ? 'warning' : 'action'}/>
                            </Tooltip>
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button onClick={() => defensiv(s_app_cid.value)}>
                            <Tooltip
                                title="Abwehrhaltung +3 auf Körperliche und Mystische Verteidigung; -3 auf alle Aktionsproben (außer Niederschlagsproben)">
                                <SafetyCheckIcon color={s_char_mods_defensiv.value ? 'warning' : 'action'}/>
                            </Tooltip>
                        </Button>
                    </Grid>
                    {s_app_sl.value ? <Fragment>
                        <Grid item xs={2}>
                            <Button onClick={() => bedraengt(s_app_cid.value)}>
                                <Tooltip
                                    title="Bedrängt -2 auf Körperliche und Mystische Verteidigung; -2 auf Aktionsproben">
                                    <GroupsIcon color={s_char_mods_bedraengt.value ? 'warning' : 'action'}/>
                                    {/* +3 auf Körperliche und Mystische Verteidigung; -3 auf alle Aktionsproben (außer Niederschlagsproben) */}
                                </Tooltip>
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={() => niedergeschlagen(s_app_cid.value)}>
                                <Tooltip
                                    title="Niedergeschlagen -3 auf Körperliche und Mystische Verteidigung; -3 auf Aktionsproben">
                                    <ArrowCircleDownIcon
                                        color={s_char_mods_niederschlag.value ? 'warning' : 'action'}/>
                                    {/* +3 auf Körperliche und Mystische Verteidigung; -3 auf alle Aktionsproben (außer Niederschlagsproben) */}
                                </Tooltip>
                            </Button>
                        </Grid>
                    </Fragment> : null}
                </Grid>

                {/*
                        <Grid item xs={1}>
                            <Button>
                                <Tooltip title="Aufteilen der Bewegung">
                                    <AltRouteIcon/>
                                    Erlaubt eine Bewegungs-/Aktions-/Bewegungs-Kombination; Charakter gilt als Bedrängt
                                </Tooltip>
                            </Button>
                        </Grid>
                        <Grid item xs={1}>
                            <Button>
                                <Tooltip title="Angriff zum Niederschlag">
                                    <VerticalAlignBottomIcon/>

                                    Statt einen Gegner im Nahkampf mit dem Ziel anzugreifen,
                                    ihn zu verletzen, kann ein Charakter auch versuchen, ihn niederzuschlagen.
                                    Der Charakter legt wie gewohnt seine Nahkampfangriffsprobe
                                    ab. Trifft der Angriff, muss der Gegner eine
                                    Niederschlagsprobe ablegen, selbst wenn der verursachte Schaden
                                    normalerweise keine Probe erforderlich machen würde. Der
                                    Angreifer legt eine Schadensprobe ab, um den Mindestwurf
                                    für die Niederschlagsprobe festzulegen, modifiziert durch die
                                    Rüstung des Gegners. Unabhängig vom Ergebnis erleidet der
                                    Gegner keinen Schaden.


                                    Standard
                                    Der Spieler legt eine Stärkeprobe gegen einen
                                    Mindestwurf gleich der Differenz zwischen dem verursachten
                                    Schaden und seiner Wundschwelle ab. Wenn die Probe gelingt,
                                    bleibt der Charakter stehen, ansonsten ist er niedergeschlagen
                                    (siehe Situationsmodifikatoren, S. 230).


                                </Tooltip>
                            </Button>
                        </Grid>
                        <Grid item xs={1}>
                            <Button>
                                <Tooltip title="Angriff zum Betäuben">
                                    <ThunderstormIcon/>
                                     keine wunden nur betäubung

                                                proben/verteidigung

                                </Tooltip>
                            </Button>
                        </Grid>
                        <Grid item xs={1}>
                            <Button>
                                <Tooltip title="Aufspringen">
                                    <KeyboardDoubleArrowUpIcon/>
                                    Erlaubt dem Charakter, aufzuspringen und eine Standardaktion auszuführen. Keine weitere Bewegung erlaubt.
                                    Wenn der verursachte Schaden die Wundschwelle eines
                                    Charakters um 5 oder mehr übertrifft, wird er eventuell niedergeschlagen.
                                    Der Spieler legt eine Stärkeprobe gegen einen
                                    Mindestwurf gleich der Differenz zwischen dem verursachten
                                    Schaden und seiner Wundschwelle ab. Wenn die Probe gelingt,
                                    bleibt der Charakter stehen, ansonsten ist er niedergeschlagen
                                    (siehe Situationsmodifikatoren, S. 230).

                                </Tooltip>
                            </Button>
                        </Grid>

                        Ein Charakter kann seine Standardaktion auch verwenden,
                        um sich zu bewegen, wodurch er eine maximale Distanz gleich
                        seiner doppelten Bewegungsrate in Schritt zurücklegen kann.


                        </Grid>
                    */}
            </Grid>
        </Grid>
    </Paper>
}

export default Initiative